<template>
  <div class="shop-index">
    <div class="top-bar">
      <div class="top-shop-info">
        <img :src="profile.shop.logo | default_img" alt="" class="shop-logo" />
        <div class="shop-info">
          <div class="shop-name">{{profile.shop.shop_name}}</div>
          <div class="count-box">
            <div class="count-item">作品数{{profile.design_count}}</div>
            |
            <div class="count-item">{{profile.shop && profile.shop.fans_count || 0}}人关注</div>
          </div>
        </div>
      </div>
      <div class="top-shop-operation">
        <template v-if="is_login && userInfo.code == uid">
            <div class="operation-item" @click="$router.push({name:'ShopManage',query:{uid,menu:'info',logType:1,'isEdit':true}})">编辑信息</div>
            <div class="operation-item" @click="$router.push({name:'WorkBenchMyTemplate'})" >上架商品</div>
            <div class="operation-item" @click="$router.push({name:'ShopManage',query:{uid,menu:'products',logType:1}})">商品管理</div>
        </template>
        <div class="operation-item share-btn" @click="onShareShop">
          <img
            src="../../assets/images/shop/icon-share-shop-version-2.png"
            alt=""
            class="icon-share"
          />分享店铺
        </div>
      </div>
    </div>
    <div
      class="shop-banner"
      :style="{ 'background-image': `url(${default_banner})` }"
    ></div>
    <div class="shop-tabs">
      <div
        v-for="(item, index) in tab_list"
        :key="`shop-tab-${index}`"
        :class="['tab-item', { active: curr_tab == item.value }]"
        @click="curr_tab = item.value"
      >
        {{ item.name }}
      </div>
    </div>
    <div class="content-body">
      <div class="content-container">
        <div v-if="curr_tab=='products'" class="product-list">
          <div class="list-top-bar">
            <div class="left-bar">
              <div class="category-list">
                <div
                  v-for="(item, index) in category_list"
                  :key="`category-index-${index}`"
                  :class="[
                    'category-item',
                    { active: item.product_category_id == curr_cate },
                  ]"
                  @click="curr_cate = item.product_category_id"
                >
                  {{ item.category_name_cn }}
                </div>
              </div>
              <div class="filter-list">
                <div
                  v-for="(item, index) in filter_list"
                  :key="`filter-index-${index}`"
                  :class="[
                    'filter-item',
                    { active: item.value == curr_filter },
                  ]"
                  @click="onFilterClick(item.value)"
                >
                  {{ item.name }}
                  <div class="sort-box" v-if="item.sort">
                    <Icon @click.stop="onFilterClick(item.value,'asc')" type="ios-arrow-up" :color="curr_filter != item.value ? '#999' : item.sort == 'asc' ? '#666' : '#999' " size="8" />
                    <Icon @click.stop="onFilterClick(item.value,'desc')" type="ios-arrow-down" :color="curr_filter != item.value ? '#999' : item.sort == 'desc' ? '#666' : '#999'" size="8" />
                  </div>
                </div>
              </div>
            </div>
            <div class="right-bar">
              <input type="text" placeholder="搜本店" v-model="form_data.keyword" @keyup.enter="onSearch" />
              <div class="search-btn" @click="onSearch">搜索</div>
            </div>
          </div>
          <template v-if="!product_list.length">
            <Empty
                :showBtn="false"
                marginTop="42px"
                emptyType="shop_product"
                emptyText="店铺暂无商品"
                emptyTips="用设计点亮店铺,上架您的原创美衣,开启自己的专属店铺,让你的设计被更多人看见"
            />
            </template>
            <template v-else>
                <div class="product-list-container">
                    <div class="product-item" v-for="(item,index) in product_list" :key="`product-item-${index}`" @click="onProductClick(item)">
                        <div class="product-img">
                            <img :src="item.image|default_img" alt="" />
                        </div>
                        <div class="product-name">{{item.name}}</div>
                        <div class="product-price-box">
                            <div class="product-price">¥{{onPriceCpt(item)}}</div>
                            <div class="product-sales">{{item.sales}}人购买</div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div v-else class="rich-text-container">
            <div v-if="curr_tab=='designer'" class="designer-info">
                <img :src="profile.designer_pic|default_img" alt="" class="designer-pic" />
                <div class="designer-info-box">
                    <div class="name-title-box">
                        <span>{{ profile.designer_name }}</span>
                        <span>·</span>
                        <span>{{ profile.designer_title }}</span>
                    </div>
                    <div class="styles-tag">
                        <div class="tag-item" v-for="(item,index) in profile.designer_styles" :key="`tags-item-${index}`">{{ item }}</div>
                    </div>
                    <div class="designer-introduction">
                        {{ profile.designer_introduction }}
                    </div>
                </div>
            </div>
            <div class="rich-text" v-html="curr_content"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
    ProductList,
    ProfileNoAuth,
    UserProductCategoryList
} from "@/api/index.js";
import defaultBanner from "@/assets/images/shop/shop-banner-default.png";
import Empty from "@/components/Empty.vue";
import { mapState } from "vuex";
export default {
  components: {
    Empty,
  },
  data() {
    return {
      tab_list: [
        { name: "时尚推荐", value: "products" },
        { name: "品牌介绍", value: "brand" },
        { name: "设计师简介", value: "designer" },
      ],
      curr_tab: "products",
      default_banner: defaultBanner,
      product_list: [{}],
      category_list: [],
      curr_cate: 0,
      filter_list: [
        { name: "综合", value: "default" },
        { name: "销量", value: "sales", sort: "desc" },
        { name: "价格", value: "sale_price", sort: "desc" },
      ],
      curr_filter: "default",
      uid: "",
      form_data: {
        keyword: "",
        product_category_id: 0,
        page:1,
        limit:15,
        status:'onsale',
        sort_field:'default',
        sort_type:'desc'
      },
      profile:{}
    };
  },
  watch:{
    curr_cate(newVal, oldVal) {
      this.form_data.product_category_id = newVal;
      this.getProductList();
    },
  },
  computed:{
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    is_login(){
      return this.$store.state.is_login;
    },
    curr_content(){
        const {curr_tab,profile} = this;
        const {shop_desc} = profile.shop;
        switch(curr_tab){
            case 'brand':
                return shop_desc || '';
            case 'designer':
                return profile.designer_hornor || '';
        }
        return '';
    },
  },
  mounted() {
    this.uid = this.$route.query.uid;
    if(this.$route.params.keyword){
        this.form_data.keyword = this.$route.params.keyword;
    }
    this.$EventBus.$on('onHeaderSearch', (data) => {
        this.form_data.keyword = data?.keyword || '';
        console.log('onHeaderSearch',data);
        this.onSearch(); // 执行你的搜索方法
    });
    Promise.all([
        this.getProfile(),
        this.getProductCategoryList(),
        this.getProductList(),
    ])
  },
  beforeDestroy() {
    this.$EventBus.$off('onHeaderSearch');
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.$emit('changeFooter', 'mall');
    });
  },
  methods: {
    onFilterClick(field,order='desc'){
        this.curr_filter = field;
        this.form_data.sort_field = field;
        this.form_data.sort_type = order;
        const find_index = this.filter_list.findIndex(item=>{return item.value == field});
        if(find_index){
            if(this.filter_list[find_index].sort){
                this.filter_list[find_index].sort = order;
            }
        }
        this.getProductList();
    },
    onProductClick({uuid}){
        if(!uuid) return;
        if (this.userInfo.id > 0 && this.userInfo.code === this.uid) {
        this.$router.push({ name: "ProductEdit", query: { uuid } });
      } else {
        this.$router.push({ name: "GoodsDetail", params: { uuid } });
      }
    },
    onPriceCpt(product){

        if (!product) return '0.00';

        const { price_mode, product_spec, price_step } = product;
        let minPrice = 0;

        if (price_mode == 1 && Array.isArray(product_spec) && product_spec.length) {
            // 取 product_spec 中最小的 price 值
            minPrice = Math.min(...product_spec.map(v => Number(v.price) || 0));
        } else if (price_mode == 2 && Array.isArray(price_step) && price_step.length) {
            // 取 price_step 中最小的 price 值
            minPrice = Math.min(...price_step.map(v => Number(v.price) || 0));
        } else {
            // 默认取 item.price
            minPrice = Number(product.sale_price) || 0;
        }

        return minPrice.toFixed(2);

    },
    async getProductList() {
        console.log({
        ...this.form_data,
        code: this.uid,
        // status: this.userInfo.code !== this.uid ? 1 : 0,
      });
      return ProductList({
        ...this.form_data,
        code: this.uid,
        status: 'onsale',
      }).then((response) => {
        this.product_list = response.data;
        this.total_count = response.data.length;
        return this.getProductCategoryList();
      });
    },
    async getProfile() {
      return ProfileNoAuth({ code: this.uid }).then((response) => {
        this.profile = response.data;
        if(this.profile.shop.shop_banner){
            this.default_banner = this.profile.shop.shop_banner;
        }
        return response;
      });
    },
    onSearch(){
        this.form_data.page = 1;
        this.getProductList();
    },
    async onShareShop(){
        const {uid} = this;
        const uri = `${window.location.origin}/shop/home?uid=${uid}`;
        await navigator.clipboard.writeText(uri);
        this.$layer.msg('复制成功');
    },
    async getProductCategoryList() {
      return UserProductCategoryList({
        code: this.uid,
        ...this.form_data,
      }).then((response) => {
        this.category_list = [...response.data];
        let count = this.category_list
          .map((v) => v.count)
          .reduce((a, b) => a + b, 0);
        this.category_list = [
          { category_name_cn: "全部宝贝", product_category_id: 0, count },
          ...response.data,
        ];
        return response;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.shop-index {
  width: 100%;
  min-height: 100vh;
  background: #f8f9fb;
  display: flex;
  flex-direction: column;
  padding-bottom: 200px;
  .top-bar {
    width: 100%;
    padding: 0 184px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    .top-shop-info {
      display: flex;
      align-items: center;
      column-gap: 12px;
      .shop-logo {
        width: 60px;
        height: 60px;
        border: 1px solid #e3e3e3;
        border-radius: 8px;
      }
      .shop-info {
        display: flex;
        flex-direction: column;
        row-gap: 6px;
        .shop-name {
          color: #333;
          font-size: 20px;
        }
        .count-box {
          display: flex;
          align-items: baseline;
          .count-item {
            color: #666;
            font-size: 12px;
            &:first-child {
              padding-right: 5px;
            }
            &:last-child {
              padding-left: 5px;
            }
          }
        }
      }
    }
    .top-shop-operation {
      display: flex;
      align-items: center;
      column-gap: 8px;
      .operation-item {
        display: flex;
        align-items: center;
        column-gap: 4px;
        color: #666;
        font-size: 14px;
        padding: 5px 8px;
        border: 1px solid #e3e3e3;
        border-radius: 4px;
        cursor: pointer;
        .icon-share {
          width: 16px;
          height: 16px;
        }
        &:hover,
        &.share-btn {
          border: 1px solid #ff5967;
          color: #ff5967;
        }
      }
    }
  }
  .shop-banner {
    width: 100%;
    height: 360px;
    background-size: cover;
    background-position: center;
    margin-top: 10px;
  }
  .shop-tabs {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 48px;
    margin-top: 20px;
    user-select: none;
    .tab-item {
      color: #666;
      font-size: 16px;
      cursor: pointer;
      &.active {
        color: #333;
        font-size: 18px;
        font-weight: bold;
        position: relative;
        &::after {
          content: "";
          width: 40px;
          height: 3px;
          background: #ff5967;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
  }
  .content-body {
    width: 100%;
    // height:100%;
    min-height: 773px;
    padding: 0 184px;
    margin-top: 15px;
    display: flex;
    flex-direction: column;
    .content-container {
      width: 100%;
      // min-height:100%;
      flex: 1;
      background: #fff;
      .product-list {
        width: 100%;
        flex: 1;
        padding: 18px 24px;
        min-height: 0;
        .list-top-bar {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .left-bar {
            flex: 1;
            display: flex;
            flex-direction: column;
            .category-list {
              width: 100%;
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              column-gap: 32px;
              .category-item {
                color: #666;
                font-size: 16px;
                cursor: pointer;
                &.active,
                &:hover {
                  color: #333;
                  font-weight: bold;
                }
              }
            }
            .filter-list {
              width: 100%;
              display: flex;
              align-items: center;
              column-gap: 8px;
              margin-top: 14px;
              .filter-item {
                display: flex;
                align-items: center;
                column-gap: 7px;
                color: #666;
                font-size: 14px;
                font-weight: Medium;
                cursor: pointer;
                background: #f3f6f8;
                padding: 6px 12px;
                user-select:none;
                &.active {
                  color: #fa3d5a;
                  background: #ffe9e1;
                }
                .sort-box{
                    display:flex;
                    flex-direction:column;
                    row-gap:0;
                }
              }
            }
          }
          .right-bar {
            display: flex;
            align-items: center;
            background: #f3f6f8;
            border-radius: 22px;
            width: 360px;
            height: 44px;
            padding: 0 20px;
            input {
              border: none;
              outline: none;
              flex: 1;
              background: transparent;
              padding-right: 20px;
            }
            .search-btn {
              color: #333;
              font-size: 14px;
              cursor: pointer;
              border-left: 1px solid #e3e3e3;
              padding-left: 20px;
            }
          }
        }
        .product-list-container {
            width:100%;
            display:flex;
            gap:15px;
            flex-wrap:wrap;
            margin-top:20px;
            .product-item{
                cursor:pointer;
                width:calc(100% / 6 - 15px);
                display:flex;
                flex-direction:column;
                row-gap:6px;
                .product-img{
                    width:100%;
                    height:316px;
                    border-radius:8px;
                    overflow:hidden;
                    img{
                        width:100%;
                        height:100%;
                        object-fit:cover;
                        object-position:center;
                    }
                }
                .product-name{
                    color:#333;
                    font-size:14px;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    display: -webkit-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .product-price-box{
                    display:flex;
                    align-items:center;
                    column-gap:8px;
                    .product-price{
                        color:#ff5967;
                        font-size:18px;
                        font-weight:bold;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow:ellipsis;
                    }
                    .product-sales{
                        color:#999;
                        font-size:12px;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow:ellipsis;
                    }
                }
            }
        }
      }
      .rich-text-container {
        width:100%;
        flex: 1;
        padding:32px 220px;
        box-sizing: border-box;
        overflow: hidden;
        background: #fff;
        .designer-info{
            width:100%;
            display:flex;
            column-gap:48px;
            padding-bottom:30px;
            border-bottom:1px solid #e3e3e3;
            margin-bottom:30px;
            .designer-pic{
                width:300px;
                height:377px;
                border:1px solid #e3e3e3;
                border-radius:8px;
                object-fit:cover;
                object-position:center;
            }
            .designer-info-box{
                flex:1;
                display:flex;
                flex-direction:column;
                .name-title-box{
                    display:flex;
                    align-items:center;
                    column-gap:7px;
                    span{
                        color:#333;
                        font-size:18px;
                        &:first-child{
                            font-size:22px;
                            font-weight:bold;
                        }
                    }
                }
                .styles-tag{
                    display:flex;
                    align-items:center;
                    column-gap:10px;
                    margin-top:8px;
                    .tag-item{
                        background:#f3f4f6;
                        border-radius:4px;
                        padding:5px 8px;
                        color:#333;
                        font-size:14px;
                        white-space:nowrap;
                        text-overflow: ellipsis;
                        overflow:hidden;
                    }
                }
                .designer-introduction{
                    white-space:pre-wrap;
                    box-sizing: border-box;
                    overflow:hidden;
                    margin-top:30px;
                }
            }
        }
        // 全局内容限制
        ::v-deep * {
            box-sizing: border-box;
        }

        // 图片自适应
        ::v-deep img {
            max-width: 100%;
            height: auto;
            display: block;
            margin: 10px 0;
        }

        // 表格滚动
        ::v-deep table {
            width: 100%;
            max-width: 100%;
            border-collapse: collapse;
            display: block;
            overflow-x: auto;

            td, th {
            word-break: break-all;
            }
        }

        // 代码块
       ::v-deep pre {
            white-space: pre-wrap;           // 允许换行
            word-wrap: break-word;           // 长单词断行
            max-width: 100%;                 // 最大宽度限制
            overflow-x: auto;                // 水平滚动条
            padding: 15px;
            background: #f5f5f5;
            border-radius: 8px;
            font-family: 'Courier New', monospace;
            font-size: 14px;
            line-height: 1.6;
            margin: 10px 0;
        }

        ::v-deep code {
            white-space: pre-wrap;
            word-wrap: break-word;
            max-width: 100%;
            overflow-x: auto;
            padding: 2px 4px;
            background: #eef5ff;
            border-radius: 4px;
            font-family: 'Courier New', monospace;
            font-size: 14px;
        }

        // 文本段落
        ::v-deep p, div, span, li {
            word-wrap: break-word;
            word-break: break-all;
            line-height: 1.8;
        }

        // 视频容器
        ::v-deep video {
            max-width: 100%;
            height: auto;
        }

        // iframe 嵌入
        ::v-deep iframe {
            max-width: 100%;
        }
      }
    }
  }
}
</style>
